// src/NavigationModalFooter.tsx
import { styled, useThemeProps } from "@mui/joy/styles";
import useSlot from "@mui/joy/utils/useSlot";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var name = "LevanaNavigationModalFooter";
var NavigationModalFooterRoot = styled("div", {
  name,
  slot: "root"
})(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1)
}));
var NavigationModalFooter = forwardRef(function NavigationModalFooter2(inProps, ref) {
  const props = useThemeProps({ props: inProps, name });
  const { children, ...otherProps } = props;
  const ownerState = { ...props };
  const externalForwardedProps = { ...otherProps };
  const [SlotRoot, rootProps] = useSlot("root", {
    ref,
    className: "root",
    elementType: NavigationModalFooterRoot,
    ownerState,
    externalForwardedProps
  });
  return /* @__PURE__ */ jsx(SlotRoot, { ...rootProps, children });
});
var NavigationModalFooter_default = NavigationModalFooter;

export {
  NavigationModalFooter_default
};
